import { gql } from 'src/generated/gql';

export const GET_ID_IMAGE_URL = gql(`
  query GetIdImageUrl($imageId: ID) {
    chartDocument(id: $imageId) {
      file {
        url
      }
    }
  }
`);
